import Storage from './Storage';

class SessionStorage extends Storage {
  static get<T>(key: string): T | null {
    const data = sessionStorage.getItem(key);
    if (data) return JSON.parse(data);
    return null;
  }

  static set<T>(key: string, value: T): void {
    if (value) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  }

  static remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  static clear(): void {
    sessionStorage.clear();
  }
}

export default SessionStorage;
